import { useEffect } from 'react'

import { useSessionContext } from 'hooks/SessionContext'
import { useStoreContext } from 'hooks/StoreContext'

import Api from 'services/api'

const useNotificationRecipients = () => {
  const { session: { impersonateDealerId, dealerId } } = useSessionContext()
  const resolvedDealerId = impersonateDealerId || dealerId

  const {
    notificationRecipients,
    setNotificationRecipients,
    areNotificationRecipientsLoaded,
    setAreNotificationRecipientsLoaded
  } = useStoreContext()

  useEffect(() => {
    Api.NotificationRecipients.list(resolvedDealerId)
      .then((res) => {
        setNotificationRecipients(res)
        setAreNotificationRecipientsLoaded(true)
      })
      .catch(() => {
        setNotificationRecipients(null)
        setAreNotificationRecipientsLoaded(true)
      })
  }, [resolvedDealerId]) // eslint-disable-line react-hooks/exhaustive-deps

  return { notificationRecipients, areNotificationRecipientsLoaded }
}

export default useNotificationRecipients
